(function () {
  console.log('sn validator ready', 0.5);
  const validPrefixes = ['10','11','12','13','14','16','17','18','19','20','21','22','23','26','27','33','36','37','38','39','41','43','44','46','48','55','56','58','61','66','76','77','88','91','92','94','95','99'];

  const INPUT_SEL = '.pp-service .pp-serialnumber input';
  const NEXT_SEL  = '.pp-service .gfb__footer.wizard__footer button.action.next';
  const ERROR_CLASS = 'pp-serialnumber-error';

  function isValid(value) {
    const v = (value || '').trim();
    if (v.length !== 8) return false;
    return validPrefixes.includes(v.slice(0, 2));
  }

function showError(input, show) {
  const container = input.closest('.globo-form-input')?.parentElement;
  const messagesEl = container?.querySelector('.messages');
  if (!messagesEl) return;

  let msg = messagesEl.querySelector('.' + ERROR_CLASS);
  if (show) {
    if (!msg) {
      msg = document.createElement('div');
      msg.className = ERROR_CLASS;
      msg.textContent = 'Seriennummer ungültig';
      messagesEl.appendChild(msg);
    }
  } else if (msg) {
    msg.remove();
  }
}

  function isOnActiveStep(input) {
    if (!input) return false;
    // hochlaufen bis zum panel und checken ob sichtbar
    let el = input;
    while (el && el !== document.body) {
      const style = window.getComputedStyle(el);
      if (style.visibility === 'hidden' || style.display === 'none') return false;
      el = el.parentElement;
    }
    return true;
  }

  function updateNextState() {
    const input = document.querySelector(INPUT_SEL);
    const buttons = document.querySelectorAll(NEXT_SEL);
    const active = isOnActiveStep(input);

    if (!input || !active) {
      buttons.forEach(btn => {
        btn.disabled = false;
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
      });
      return;
    }

    const valid = isValid(input.value);
    buttons.forEach(btn => {
      btn.disabled = !valid;
      btn.style.opacity = valid ? '' : '0.5';
      btn.style.pointerEvents = valid ? '' : 'none';
    });
  }

function check(input) {
  const v = input.value.trim();
  showError(input, v.length >= 8 && !isValid(input.value));
  updateNextState();
}

  function bind(input) {
    if (input.dataset.ppBound) return;
    input.dataset.ppBound = '1';
    input.addEventListener('input', () => check(input));
    input.addEventListener('blur',  () => check(input));
  }

  function scan() {
    document.querySelectorAll(INPUT_SEL).forEach(bind);
    updateNextState();
  }

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('click', () => setTimeout(updateNextState, 50));
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();